// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--3r4A6";